import { useRef, useEffect, useCallback, useState } from 'react';
import { ContactListMenu } from '@/components/message-list';
import { Storage } from '@/utils/storage';

const MIN_WIDTH = 250;
const MAX_WIDTH = 320;
const DEFAULT_WIDTH = 320;
const STORAGE_KEY = 'contact-list-width';

function readStoredWidth(): number {
  const stored = Storage.getItem<number>(STORAGE_KEY);
  if (stored === null) return DEFAULT_WIDTH;
  return Number.isFinite(stored) ? Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, stored)) : DEFAULT_WIDTH;
}

export default function ResizableContactListPanel() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(readStoredWidth);

  const isDraggingRef = useRef(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(width);

  const handleResizeMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      isDraggingRef.current = true;
      startXRef.current = e.clientX;
      startWidthRef.current = containerRef.current?.offsetWidth ?? width;
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    },
    [width]
  );

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDraggingRef.current) return;
      const delta = e.clientX - startXRef.current;
      const newWidth = Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, startWidthRef.current + delta));
      setWidth(newWidth);
      Storage.setItem(STORAGE_KEY, newWidth);
    };

    const handleMouseUp = () => {
      if (!isDraggingRef.current) return;
      isDraggingRef.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="flex-none h-screen border-r border-[#F0F0F0] bg-white overflow-hidden relative z-0"
      style={{ width }}
    >
      <ContactListMenu />
      {/* 拖拽手柄：绝对定位于容器右边缘 */}
      <div className="absolute top-0 right-0 w-1 h-full cursor-col-resize z-10" onMouseDown={handleResizeMouseDown} />
    </div>
  );
}
